import { z } from "zod";
import { ATTRIBUTION_FIELDS, CALLBACK_CONTACT_FIELDS, ORIGIN_PATH_FIELD } from "./inquiryFields";

// ============================================================================
// CALLBACK REQUEST SCHEMA (widget „Zavoláme vám" — řez 01, vize F1.9)
// ============================================================================

/**
 * Tělo `POST /api/inquiries/callback`: jen jméno a telefon, k tomu stránka původu
 * a atribuce. Žádný e-mail ani zájezd — žádost zákazníka nehledá a neslučuje (vzniká lead
 * `kind = "callback"`). Všechny hlášky jsou české, protože je widget vykresluje doslova.
 */
export const callbackRequestSchema = z.object({
  ...CALLBACK_CONTACT_FIELDS,
  originPath: ORIGIN_PATH_FIELD,
  ...ATTRIBUTION_FIELDS,
});

export type CallbackRequestInput = z.infer<typeof callbackRequestSchema>;
